import { render, staticRenderFns } from "./CollapseMod.vue?vue&type=template&id=5056e59c"
import script from "./CollapseMod.vue?vue&type=script&lang=js"
export * from "./CollapseMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports